import type { EntryPoint } from '@/apilib';
import { EditorAPIKey } from '@/apis';
import { createDeveloperModeApi } from './developerModeWrapper';
import { DeveloperModeApiKey } from './publicApiKey';

export const DeveloperModeEntrypoint: EntryPoint = {
  name: 'DeveloperModeApi',
  declareAPIs: () => [DeveloperModeApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(DeveloperModeApiKey, () =>
      createDeveloperModeApi(shell),
    );
  },
};
